import React from "react";
import { useIntl } from "react-intl";
import { Modal } from "@jelly/ui";

import styles from "./Modals.module.scss";
import { messages } from "../Recordings.messages";
import { useBlocks, useUi } from "@jelly/lesson";
import * as appConfig from "appConfig";
import { nl2p } from "@src/utils/nl2p";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

type ModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;
export const NewSessionModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P3_M_NewSession_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>
            {nl2p(formatMessage(messages.G2_P3_M_NewSession_Description))}
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_new_session_1.png`} />
            </div>
          </div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_new_session_2.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const MasterBusModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P3_M_MasterBus_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>
            {nl2p(formatMessage(messages.G2_P3_M_MasterBus_Description))}
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_master_bus_1.png`} />
            </div>
          </div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_master_bus_2.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const RecordingTracksModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P3_M_RecordingTracks_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P3_M_RecordingTracks_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_recording_tracks_1.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const PremasterModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P3_M_Premaster_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P3_M_Premaster_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_premaster_1.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const StereoFoldownAndBinauralModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P3_M_StereoFoldownAndBinaural_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>
            {nl2p(formatMessage(messages.G2_P3_M_StereoFoldownAndBinaural_Description))}
          </div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_stereo_foldown_and_binaural_1.png`}
                    />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_stereo_foldown_and_binaural_2.png`}
                    />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const StereoFoldownModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P3_M_StereoFoldown_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P3_M_StereoFoldown_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_stereo_foldown.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};
